export default __webpack_public_path__ + "static/media/nbaCardBg.57d3bf27.png";